<template>
  <div>
    <div :key="it.id" v-for="it of items">
      <div class="contentlist">
        <c-title v-if="title" :title="title"></c-title>
        <div>
          <div  class="clist" >
            {{it.title}}
          </div>
          <div v-if="it.pictureId" style="width:60px; display: inline-block; vertical-align:middle; text-align: center;">
            <img style="width:100%;" class="c-products__picture" :src="
              getImageUrl({ id: it.pictureId, width: 311, height: 207 })
            " />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";

@Component({
  props: {
    title: {
      type: String,
    },
    items: {
      type: Array,
      default: () => []
    }
  }
})
export default class ContentList extends Vue {}

</script>

<style lang="scss">
.contentlist {
    background-color: white;
    padding-right: 15px;
    padding-left: 15px;
    border-radius: 6px;
    .clist {
      padding: 4px 0;
      width: calc(100% - 80px);
      display: inline-block;
    }
    margin: 4px 0;
}
</style>
